import userService from '@/service/user';
import localStoragePerfect from '@/util/localstorage-perfect';
import commonUtil from '@/util/common';

const tags = {
    // {app, pc, h5}
    '1': {
        app: '11',
        pc: '41',
        h5: '52'
    },
    '2': {
        app: '11',
        pc: '42',
        h5: '53'
    },
    '3': {
        pc: '43',
        h5: '51'
    },
    '4': {
        pc: '44',
        h5: '50'
    },
    '5': {
        pc: '45'
    },
    '6': {
        pc: '46',
        h5: '54'
    },
    '7': {
        pc: '47',
        h5: '55',
        app: '9'
    },
    '8': {
        pc: '48',
        h5: '56'
    },
    '9': {
        pc: '49',
        h5: '49'
    },
    '10': {
        pc: '57',
        h5: '57'
    },
    '11': {
        pc: '58',
        h5: '58'
    },
    '12': {
        app: '33',
        pc: '59',
        h5: '60'
    },
    // 首页
    '13': {
        pc: '65',
        h5: '70'
    },
    // l9介绍页
    '14': {
        pc: '67',
        h5: '71'
    },
    // l8介绍页
    Product_L8: {
        pc: '75',
        h5: '78'
    },
    // l7介绍页
    Product_L7: {
        pc: '76',
        h5: '77'
    },
    // Mega介绍页
    MEGA: {
        pc: '', // todow
        h5: ''
    },
    // 订单详情
    '15': {
        pc: '66',
        h5: ''
    },
    // 门店
    '16': {
        pc: '68',
        h5: ''
    },
    // 预约试驾
    '17': {
        pc: '69',
        h5: ''
    },
    // 广告投放页
    '18': {
        pc: '72'
    },
    Configuration_X01: {
        pc: '80',
        h5: '86'
    },
    Configuration_X02: {
        pc: '81',
        h5: '85'
    },
    Configuration_X03: {
        pc: '82',
        h5: '83'
    },
    Configuration_Compare: {
        pc: '89',
        h5: '88'
    }
};

function urlAddQuery(url, arg, argVal) {
    const urlObj = new URL(url);
    urlObj.searchParams.set(arg, argVal);
    return urlObj.href;
}

async function goWebIM(autoFlag = 'autoImOpen', isJumpLogin = true, tag = '') {
    const userAgent = navigator.userAgent;
    const os = {
        iphone: userAgent.indexOf('iPhone') !== -1,
        android: userAgent.indexOf('Android') !== -1
    };
    const { iphone, android } = os;
    const device = android || iphone ? 'm' : 'pc';

    let isLogin = localStoragePerfect.getItem('isLogin') === 'true';

    let entry = tags[tag] ? tags[tag].h5 || '' : '';
    if (device === 'pc') {
        const { code } = await userService.checkLogin();
        isLogin = code === 0;

        entry = tags[tag] ? tags[tag].pc || '' : '';
    }

    if (!isLogin) {
        if (isJumpLogin) {
            localStoragePerfect.setItem(`${autoFlag}_tag`, tag);
            const url = urlAddQuery(
                window.location.href,
                'registerAction',
                '108'
            );
            commonUtil.goLogin(url);
        }

        return;
    }

    const iLeft = (window.screen.width - 590) / 2;
    const iTop = (window.screen.height - 625) / 2;

    // im im-qy
    const url = `/im-qy.html?entry=${entry}&originalUrl=${window.location.href}&device=${device}`;

    window.open(
        url,
        'chat',
        `width=590,height=625,left=${iLeft},top=${iTop},toolbar=no, menubar=no, scrollbars=no, resizable=no,location=no, status=no');`
    );
}

/**
 * tag: 打开客服的入口
 */

function goIM(autoFlag = 'autoImOpen', tag) {
    goWebIM(autoFlag, true, tag);
}

export default {
    goIM
};
